export const QualyProms = (ratings: any) => {
  if (!ratings || ratings.length == 0) {
    return 0;
  }
  let prom = 0;
  let cant = 0;

  ratings.map((qualy: any) => {
    Object.keys(qualy).map((key) => {
      if (
        key !== "user" &&
        key !== "created_at" &&
        key !== "description" &&
        key !== "user_id" &&
        key !== "property_id" &&
        key !== "excursion_id"
      ) {
        prom = qualy[key] + prom;
        cant++;
      }
    });
  });

  return Math.round(prom / cant);
};
